export default function generateRandomBw (start, end) {
  return Math.floor( (Math.random() * end ) + start );
}